import React, { FC, useEffect, useState, startTransition } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Alert,
  Grid,
  Box,
  Divider,
  CardMedia,
  Button,
} from '@mui/material';
import clientService from 'src/clientService';
import { ProjectAdminDetail, Site } from 'src/api/Api';
import { formatDate, getDuration } from 'src/util/date-utils';

const staticImageUrls = [
  'https://lh3.googleusercontent.com/aida-public/AB6AXuA7lFzjYdlr9y9BbnIPj4c1sd0RPVrNfHhgrEhLwfWPgIS0DpS2YpnkmSwDbsjj9GGv6chgvnMI30UekCaC97EF7aQ-MA4my5k9rlkO0cmPqqlqjFoUinQeg1ewdjNK9KsvEP68bl2VtUs_r-ijuE15jKjTw_FIzLS3wdqF2US4YG8-3sfFoNTpWsmU_d9olRK-oXsV5mnnYP6xrWkrCbm6aZA0DpchlnWgWnlCauMyFkY4OhoDTYgOG5KyZiQ4zokfOUqPTrm51w',
  'https://lh3.googleusercontent.com/aida-public/AB6AXuAb51SgRjO4F7KTAMqH0kuzdgoFX-70E63boORm_Et4Ff-5O7CKrtlkzdL-JFMlzKHPjxZ60ON9_jOpjpAukkJS6cp6CXEi_-Vi_wzWj31ET1AS-l5ClKKeijeozQuVd_PnzlqZO0wOPS6kGmEDUuaomYx0ypT7uGKmJx-SFuK8z-kxodEs8qs7ejDT9_lHrR-gd88IoHr8oMWtZ2UvTQRIhlXCN_j5lpMlrC4VUtKMYN6I-yQrTls2wHJ-hiiAC0Cn4k0KXdEEOg',
  'https://lh3.googleusercontent.com/aida-public/AB6AXuAl3RLi-X7VoMTUHZgOMXKu4h205mzwF3Z6k3PJE8UWkiWgHLp3XCLE49DFg8E-xwje82NmxQf41qgS_dTX9quvsK7Z8eAdKYsR71P5F0WVVhsWcclDY_PxTBSxJ9XACvQU0v-YbkuU0oZKoQNwC5q6K-44Yh8Xtg7lymbjaPIbSAzOTiNPquH0-BS2b0RKrTrjOvAmPqxUNftjADY6PHsQbXdIu6FpwtUqJJt3J3H0n0TGWnxBodiNaWPX8IBn0jo9r9zs29Oz1A',
  'https://lh3.googleusercontent.com/aida-public/AB6AXuAn_snBmkZVsWzCuWQttwlMtTIlhgVR07Afx-BVISCcPGwegZSASlrbeJkzPTkt4XtwSsxMkS4z_0ocCs6RAvyLvarWRwbGCczFbgknGyCAooaMsODwvKOBQRgkir3soQavY7KGsPAm2UX6vkj4rM9LZiy2peNuKc6eNeaWdmqnmMeuhmKYft1HeoBLeOmWHV9MCaBf6sh3tMIG6c2BhPQo_cU_Pseauwx5WqfZF11jUMGPAsdq-3ra9sRr_TOVKRuIDJuECsSc4w',
  'https://lh3.googleusercontent.com/aida-public/AB6AXuDM-rYJSVCg3k0DZ_IL76iMif5LDyskQTw7V1XcldD-Oo4_3QnivpnkUuu2SBSrjzv0d5SlAxHX-yz2vTigWHTY29mn0KsrghJ6IUb86FHRlj3Ega9ZHmzHw0ejgLF3nenkh4tHwllKuiDR7HwO9JNuL14_W_gXcsc40V_AVnCfSsEX3N_Y3P9Rzs3ImpcOh91q3uXhziulCqZY3hyUEkQ_FAETu4M2A4QFrwGFQn0Vp0hujkMqQkk8w7eIScWEHbSwnpeS4_ffcw',
  'https://lh3.googleusercontent.com/aida-public/AB6AXuDTujNSzCKPlPCC5VspJ5QTlLx5AiJ-f4_x5dBoS-nJJBwTzZmINsikyiu2yuSY0OhJQ_S43m65rpcftXxdEOcnkasOnl2Ckzt8W7dFeZJxbxOWVGk16N2oKnfxULyqFuVjooLUK7y5YnirDqQxcbrc75YC7qw_5yiRI7IXAZqbFH5I5k7cILXQwtcSTIVFjwOrzwN4jPksXC4x39GY-WoPN82SsomSZFe0vLz3jiUncjgrbzeGD-xv9Wazk70q0mJvkHrbxWGiSA',
  'https://lh3.googleusercontent.com/aida-public/AB6AXuDbIcwwEvEG7wvwHuenMe2LfPOowgspwm_XcmGaXibh-H76VC68ZHaa1wSepbB4UzLeElToXtQInhLlBcO4ByWRn_oS1VN0_7q3X21gc3MqlzBVYTf4hCepq6qfGvJhORnSLYJxdWQi4R2jew1MygPbu2gXPVP2i4dai6RE5kkyKama9WQ-bjtx_KYnvCD49e_djSKx8UMkfOX0H3_fqj1cP4jw2zAfKHQ5q1POIMEhgmwa9pVweWWXXGhg7d7fv4J0v_i4bhw3rA',
  'https://lh3.googleusercontent.com/aida-public/AB6AXuB2R_nMHHdkP788p2HYqM4vUy0cJecLPo8wir99menQ0WJQqklno2VjvjIK7Xw8pMOsmw5UJaVOR56jwg6T6FafIXdXwLgns-k43WljsduFMhR4sVZrcmpeWeTcWUxh0d4Q8FKnU070GbilmeqSZqrhyrqb4rzcF4qLJ9OrxQ5NvP6y-9Gg4-06OQyKYQ4lbIRfV5Oy-ApDvwsnggNGaj4zjgX6x75-HCy1s9Pn9YXu1ga6yW8_-tZ5fkjVLyeGc-WhYsmw7o5OLQ',
  'https://lh3.googleusercontent.com/aida-public/AB6AXuDWlTnzv2yCRwK92MpzYuYmgJhdH0TpPoIhseWBghWVZFmHQk1cFG9l25WRE9AgpRxjbfo0BEDWkPycEAKWBvdr0Hx7m08__vKVJ0hV5nSba0nHIE2pUsnKv1fxqtyprElNop_aoFVMaxz4CH4L4gY2CRNx3k1aKvBUOhouGqlYOaTV-v6dHMOf0Jd16om7E0uw4Lfb8c32AStl_a4b87NDktpNZ-3cj0luHgob0h6X3o2aktNGUS1jMGo-dK6tzdm0EUH-AXO81Q',
  'https://lh3.googleusercontent.com/aida-public/AB6AXuAT2EIRJIRdfs8dbdu-qRiTtDjAbGVyWX9s1x2nG5hQynkOnTx8qMINrvtSvOBmNaQmJl-jGLv5BwU9Icz7LyhH4etoUf4TQ1XXxuaHC_WGzkEnUXPV57HOsfAGaghbfxPgTXknD4omt8IMc-Ck7xpqIaplZgt6wFcrj0QpoONjuau5BFf1_ybHXHGTY02EryTZSSt_drMGSwI8-HOWqV6Z5_kF7AnzuaUhheGQdPjtEUC4GUGbP9MR145aGy3S-aa2WRoidSNBHg',
  'https://lh3.googleusercontent.com/aida-public/AB6AXuCdL30-HYYkNyIwbjCtTWEb_7aqyV8vgYFIDV1rU7UJq6Ruc8_xaMfFbBQqOJ7TtUvW-qSkXTttodDgr3FHoRxuU23lXn2hwWjNiv71qX3NJ4mhkcrvjXfHwYjWv-GBZUngPP97nmrk2MLZXDl1lTjtsO44aSJ56t7k1JvJCJj48j8ZT8KYZYbhM_JztP3AMMZYj1MDkUJfUrEZs14pnuHsYfIxku8Xi-ldp3yMZANts6t0I4aYnIENFFUU7zqAEKzlzxGgnhVhiw',
  'https://lh3.googleusercontent.com/aida-public/AB6AXuAMu96jmbnQLq0ZVAwhYwcFwopzU4NyRO_eYPstSkjkwe6LT5tUVcCnCX3fikhgwC1DQ_HnrBUBtepGodju8n2DqSJzra4C9ko6gkyXpEpl0gQfoyWgAxmEHbHMkdPtwNqrGCcJWFYXJuBYFbLRgjHvrWa9MTlAm8NPR2gLQ-1dsMcWm67KnUIHKg3U_pqWEbomn7USTkhZ5fA8P9lwoXkh4NG2et9tSl4oc7lL7Sq5ZPcO26o0t94Od5kxT5_Y6DpsM9TRSyGKBA',
];

const ProjectDetails: FC = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const navigate = useNavigate();
  const [project, setProject] = useState<ProjectAdminDetail | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchProjectDetails = async () => {
      if (!projectId) return;
      setLoading(true);
      try {
        const response = await clientService.api.getProjectDetailsAdminApiV1AdminProjectsProjectIdGet(projectId);
        setProject(response.data);
      } catch (err) {
        setError('Failed to fetch project details.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchProjectDetails();
  }, [projectId]);

  if (loading) {
    return <CircularProgress />;
  }

  if (error) {
    return <Alert severity="error">{error}</Alert>;
  }

  if (!project) {
    return <Typography variant="h6">Project not found.</Typography>;
  }

  const DetailItem: FC<{ label: string; value: React.ReactNode }> = ({ label, value }) => (
    <Grid item xs={12} md={6} sx={{ borderTop: '1px solid #dbe1e6', py: 2 }}>
      <Typography color="text.secondary" variant="body2">{label}</Typography>
      <Typography variant="body1">{value || '-'}</Typography>
    </Grid>
  );

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h5" component="h1" fontWeight="bold">
          {project.project_name}
        </Typography>
        <Button
          variant="contained"
          onClick={() => navigate(`/admin/project/${projectId}/media`)}
        >
          Manage Media
        </Button>
      </Box>

      <Card>
        <CardContent>
          <Typography variant="h6" component="h2" fontWeight="bold" sx={{ mb: 2 }}>
            Details
          </Typography>
          <Grid container spacing={2}>
            <DetailItem label="Description" value={project.project_description || 'This project aims to restore and expand forest cover in ecologically sensitive areas.'} />
            <DetailItem label="Type" value={project.project_type} />
            <DetailItem label="Start Date" value={formatDate(project.project_start_date)} />
            <DetailItem label="End Date" value={formatDate(project.project_end_date)} />
            <DetailItem label="Duration" value={getDuration(project.project_start_date, project.project_end_date)} />
            <DetailItem label="Country" value={project.country} />
            <DetailItem label="Developer" value={project.project_developer} />
            <DetailItem label="Status" value={project.project_status} />
          </Grid>
        </CardContent>
      </Card>

      <Box sx={{ mt: 4 }}>
        <Divider sx={{ mb: 2 }} />
        <Typography variant="h6" component="h2" fontWeight="bold">
          Registered Sites
        </Typography>
        <Grid container spacing={3} sx={{ mt: 1 }}>
          {project.sites && project.sites.map((site: Site, index: number) => (
            <Grid item key={site.site_id} xs={12} sm={6} md={4} lg={3}>
              <Card onClick={() => startTransition(() => navigate(`/admin/project/${projectId}/site/${site.site_id}`))} style={{ cursor: 'pointer' }}>
                <CardMedia
                  component="img"
                  height="140"
                  image={staticImageUrls[index % staticImageUrls.length]}
                  alt={site.site_name}
                />
                <CardContent>
                  <Typography gutterBottom variant="h6" component="div">
                    {site.site_name}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default ProjectDetails;
